<template>
<div class="container-fluid" style="overflow: hidden;">
  <div class="container"  style="overflow: hidden;">

  
  <div class="card change_psw_card">
	<div class="change_pswd_pg">
		<h3 class="card-title text-center">Change password</h3>
		
		<!--Password must contain one lowercase letter, one number, and be at least 7 characters long.-->
		
		<div class="card-body">
			<form>
          <div class="form-group">
					<label for="email">Email</label>
					<input type="email" v-model="email"  class="form-control input_field_pc" required>
				</div>
        <div class="form-group">
					<label for="exampleInputEmail1">Your Old password</label>
					<input type="password" v-model="oldPassword" class="form-control input_field_pc" required>
				</div>
				<div class="form-group">
					<label for="exampleInputEmail1">Your new password</label>
					<input type="password" v-model="newPassword" class="form-control input_field_pc" required>
				</div>
				<div class="form-group">
					<label for="exampleInputEmail1">Repeat password</label>
					<input type="password" v-model="repeatPassword" class="form-control input_field_pc" required>
				</div>
				<button type="button"  @click="submitPassword" class="btn btn-primary btn-block submit-btn">Confirm</button>
			</form>
		</div>
	</div>
</div>

</div>
</div>
</template>
 
<script>
// import { mapState } from "vuex";
import { notifyWarn,notify, notifyError } from "@/utils/notification-helper";
import { mapGetters } from "vuex";

export default {

   data: function () {
    return {
         oldPassword:null,
         newPassword:null,
         email:null,
         repeatPassword:null,
    }

   },
  methods: {
         submitPassword(){
           if(this.repeatPassword != this.newPassword){
             notifyWarn("Password does not match")
             return
           }
           let data= {
              //  "email":this.email,
                "newPassword": this.newPassword,
                "currentPassword":this.oldPassword,
                "confirmPassword": this.repeatPassword
           }
           if(this.email && this.newPassword && this.oldPassword && this.repeatPassword)
           {
             this.$store.dispatch("changPwd",data).then(res=>{
                if(res.data.status){
                    notify(res.data.message)
                     this.$store.dispatch("oidcStore/signOutOidc");
                    localStorage.removeItem("isActive");
                }
                else{
                    notifyWarn(res.data.message)
                }
            }).catch((err) => {
              try {
                console.error('ERROR : ', err);
                notifyWarn( err.response.data.message);
              } catch (err) {
                console.error('Error', err);
                notifyError('Something went wrong');
              }
            });
           }
         },
         getDataOnload(){
          this.email = this.oidcUser.email
         }
  },
  mounted() {
    this.getDataOnload();
  },

  created() {
   
  },
    computed: {
    ...mapGetters("oidcStore", ["oidcUser"]),
  
  },
   

};
</script>
 
<style lang="scss">
.card{
    form{
        width: 440px;
    }
form{
	padding-top: 10px;
	font-size: 13px;
	margin-top: 30px;
}

.card-title{ font-weight:600; font-size: 20px; text-transform: uppercase; letter-spacing: 0.5px; }

.btn{
	font-size: 13px;
}

.login-form{ 
	/* width:320px; */
	margin:20px;
}

.sign-up{
	text-align:center;
	padding:20px 0 0;
}

span{
	font-size:14px;
}

.submit-btn{
  font-size: 18px;
  text-transform: uppercase;
	margin-top:20px;
  padding: 6px;
}
}
.change_pswd_pg{
  background: #ffffff;
  margin: 20px 10px;
  padding: 25px;
  border-radius: 2px;
  border: 1px solid #80808029;
}
.change_psw_card{
  display: flex;
  justify-content: space-around;
  text-align: center;
  margin: 54px 0px;
}
.form-group{
  label{
    padding: 2px;
    margin: 8px 0px;
    text-align: left;
  }
  .input_field_pc{
   border-radius: 2px;
  }
}

@media only screen and (max-width: 768px) {
  .card{
    form{
        width: 100%;
    }
form{
	padding-top: 5px;
	font-size: 13px;
	margin-top: 10px;
}
.card-title{font-size: 12px;}
  }
.change_pswd_pg{
  background: #ffffff;
  margin: 10px 10px;
  width: 100%;
  padding: 10px;
  border-radius: 2px;
  overflow: hidden;
  border: 1px solid #80808029;
}
.change_psw_card{
  display: flex;
  justify-content: left;
  text-align: center;
  margin: 54px 0px;
}
.form-group{
  padding: 0px 10px;
  width: auto;
  overflow: hidden;
  label{
    text-align: left;
  }
  .input_field_pc{
   border-radius: 2px;
  }
}
}
</style>